export default {
  // 获取客户服务
  GET_LIST: '/jcnapi/customerService/getList',
  DEL: '/jcnapi/customerService/delete',
  //保存
  SAVE: '/jcnapi/customerService/save',
  GET: '/jcnapi/customerService/getInfo',
  //基本设置
  SET_BASE: '/jcnapi/customerService/setBase',
  //设置售前支持
  SET_SUPPORT: '/jcnapi/customerService/setSupport',
  //设置助您入门
  SET_CETSTART: '/jcnapi/customerService/setGetStart',
  //设置保持运行
  SET_KEEP_RUNNING: '/jcnapi/customerService/setKeepRunning',
  //设置未来管理
  SET_FUTURE_MANAGER: '/jcnapi/customerService/setFutureManager'
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/modules/customerService/index.js